import { AlertTriangle, Grape, RotateCcw } from "lucide-react";
import type { ReactNode } from "react";

export function PageLoader({ label = "Chargement de votre cave…" }: { label?: string }) {
  return (
    <div className="page-loader" role="status" aria-live="polite">
      <div className="loader-mark" aria-hidden="true">
        <Grape size={28} />
      </div>
      <p>{label}</p>
      <span className="sr-only">Chargement en cours</span>
    </div>
  );
}

export function ErrorState({
  title = "Impossible d’afficher votre cave",
  message = "La connexion a rencontré un problème. Vos données n’ont pas été modifiées.",
  onRetry,
}: {
  title?: string;
  message?: string;
  onRetry?: () => void;
}) {
  return (
    <div className="state-card state-error" role="alert">
      <span className="state-icon">
        <AlertTriangle size={25} aria-hidden="true" />
      </span>
      <h2>{title}</h2>
      <p>{message}</p>
      {onRetry ? (
        <button className="button button-secondary" type="button" onClick={onRetry}>
          <RotateCcw size={17} aria-hidden="true" />
          Réessayer
        </button>
      ) : null}
    </div>
  );
}

export function EmptyState({
  icon,
  title,
  message,
  action,
}: {
  icon?: ReactNode;
  title: string;
  message: string;
  action?: ReactNode;
}) {
  return (
    <div className="state-card state-empty">
      <span className="state-icon">{icon ?? <Grape size={27} aria-hidden="true" />}</span>
      <h2>{title}</h2>
      <p>{message}</p>
      {action}
    </div>
  );
}

